import React from "react";
import { useDispatch } from "react-redux";

import { useMatch, NavLink } from "react-router-dom";
import { filterProject } from "../redux/features/filter/filterSlice";
import useAuth from "../hooks/useAuth";

import Logo from "../assets/logo.png";
import { logoutUser } from "../redux/features/auth/authSlice";

function Navbar() {
  const [open, setOpen] = React.useState(false);
  const { user } = useAuth();
  const match = useMatch("/projects");
  const dispatch = useDispatch();

  const handleChange = (value) => {
    dispatch(filterProject(value));
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, 500);
    };
  };

  const debounceDispatch = debounce(handleChange);

  return (
    <div className="flex items-center flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75">
      <img src={Logo} alt="Lgog" className="h-10 w-10" />
      {match && (
        <input
          className="flex items-center h-10 px-4 ml-10 text-sm bg-gray-200 rounded-full focus:outline-none focus:ring"
          type="search"
          placeholder="Search for anything…"
          onChange={(e) => debounceDispatch(e.target.value)}
        />
      )}
      <div className="ml-10">
        <NavLink
          to="/teams"
          className={({ isActive }) =>
            isActive
              ? "mx-2 p-2 bg-indigo-700 text-white rounded-lg font-semibold"
              : "mx-2 p-2 bg-gray-200 text-gray-600 rounded-lg font-semibold"
          }
        >
          Teams
        </NavLink>
        <NavLink
          to="/projects"
          className={({ isActive }) =>
            isActive
              ? "mx-2 p-2 bg-indigo-700 text-white rounded-lg font-semibold"
              : "mx-2 p-2 bg-gray-200 text-gray-600 rounded-xl font-semibold"
          }
        >
          Projects
        </NavLink>
      </div>
      <div className="relative ml-auto	">
        <button
          className="relative flex items-center justify-center w-8 h-8 ml-auto overflow-hidden rounded-full cursor-pointer"
          onClick={() => setOpen(!open)}
        >
          <img
            src="https://assets.codepen.io/5041378/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1600304177&width=512"
            alt=""
          />
        </button>
        {open ? (
          <div className="right-[4px] absolute z-10 w-44 bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600">
            <div className="py-3 px-4 text-sm text-gray-900 dark:text-white">
              <div>{user?.name}</div>
              <div className="font-xs truncate">{user?.email}</div>
            </div>

            <div className="py-1">
              <a
                href="#"
                className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                onClick={() => dispatch(logoutUser())}
              >
                Logout
              </a>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Navbar;
